import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useI18n } from '../context/I18nContext';

export default function CustomSystemCTA() {
  const { tr } = useI18n();
  const stats = [
    { value: '500+', label: tr('custom_cta.happy_customers', 'Mutlu Müşteri') },
    { value: '50+', label: tr('custom_cta.custom_systems', 'Özel Sistem') },
    { value: '24/7', label: tr('custom_cta.tech_support', 'Teknik Destek') },
    { value: '99.9%', label: tr('custom_cta.uptime', 'Uptime Garantisi') },
  ];

  return (
    <section className="relative py-20 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(228,180,78,0.1),transparent_60%)]" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
        <div className="relative rounded-3xl overflow-hidden border border-[#e4b44e]/25 bg-gradient-to-br from-[#141110] via-[#0d0c10] to-[#0a090c] p-10 md:p-16">
          <div className="absolute -top-32 -right-20 w-96 h-96 rounded-full bg-[#e4b44e]/10 blur-3xl" />
          <div className="absolute -bottom-32 -left-20 w-96 h-96 rounded-full bg-[#e4b44e]/6 blur-3xl" />

          <div className="relative grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#e4b44e]/10 border border-[#e4b44e]/30 mb-6">
                <Sparkles className="w-3.5 h-3.5 text-[#f4d896]" />
                <span className="text-[11px] font-extrabold tracking-[0.28em] text-[#f4d896]">{tr('custom_cta.eyebrow', 'ÖZEL GELİŞTİRME')}</span>
              </div>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6">
                <span dangerouslySetInnerHTML={{ __html: tr('custom_cta.title_1', 'Özel Bir Sisteme <br />') }} /> <span className="gold-text">{tr('custom_cta.title_2', 'İhtiyacınız mı Var?')}</span>
              </h2>
              <p className="text-lg text-white/70 leading-relaxed mb-8 max-w-lg">
                {tr('custom_cta.subtitle', 'Ekibimizin özel kodlama ve modelleme hizmetlerinden yararlanarak hayalinizdeki sunucuyu birlikte inşa edelim.')}
              </p>
              <div className="flex flex-wrap gap-4">
                <a href="/contact" className="btn-gold inline-flex items-center gap-2 h-13 px-8 py-4 rounded-full text-sm font-extrabold tracking-widest">
                  {tr('custom_cta.contact', 'İLETİŞİME GEÇ')} <ArrowRight className="w-4 h-4" />
                </a>
                <a href="/projelerimiz" className="btn-outline-gold inline-flex items-center gap-2 h-13 px-8 py-4 rounded-full text-sm font-bold tracking-widest">
                  {tr('custom_cta.projects', 'PROJELERİMİZ')}
                </a>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 hover:border-[#e4b44e]/40 transition">
                  <div className="font-display text-4xl md:text-5xl font-black gold-text mb-2">{s.value}</div>
                  <div className="text-xs tracking-widest text-white/60 uppercase">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
